/* eslint camelcase: 0 */

import { request, instance } from "../../helpers/axios.new";

const ZAPIER_CLIENT_ID = process.env.REACT_APP_ZAPIER_CLIENT_ID;
const REDIRECT_URI = `${process.env.REACT_APP_FRONTEND}/zapier-auth`;
const ZAPIER_AUTH_URI = "https://zapier.com/oauth/authorize";

export const GET_ZAPIER_AUTH_URL = () => {
  const zapierAuthUrl = `${ZAPIER_AUTH_URI}?client_id=${ZAPIER_CLIENT_ID}&redirect_uri=${REDIRECT_URI}&response_type=token&scope=zap%20profile`
  return zapierAuthUrl;
};

export const POST_EMBED_TOKEN = ({
  access_token,
  token_type,
  refresh_token,
  expires_in,
}) => {
  return request({
    url: `/zapier/token`,
    method: "POST",
    data: {
      parameters: {
        access_token,
        token_type,
        ...(refresh_token && { refresh_token }),
        ...(expires_in != null && { expires_in }),
      },
    },
  });
};

/**
 * Check if user is already connected to Zapier so they only connect once.
 * Uses instance directly so 401 (needsReconnect) does not trigger app-wide signout.
 */
export const GET_USER = () => {
  const authToken = localStorage.getItem("token");
  return instance
    .get("/zapier/user", {
      headers: {
        "Content-Type": "application/json",
        ...(authToken && { Authorization: `Bearer ${authToken}` }),
      },
    })
    .then((res) => res)
    .catch((err) => {
      if (err.response?.status === 401) {
        const body = err.response?.data || {};
        const e = Object.assign(
          new Error(body.message || "Not connected"),
          { needsReconnect: body.needsReconnect }
        );
        throw e;
      }
      throw err;
    });
};

export const GET_ZAP = (id) => {
  return request({
    url: `/zapier/zaps/${id}`,
    method: "GET",
  });
};

export const GET_ZAPS = () => {
  return request({
    url: `/zapier/zaps`,
    method: "GET",
  });
};

export const LINK_KPIS = () => {
  return request({
    url: `/zapier/link-kpis`,
    method: "PUT",
  });
};